import { 
    PASARGADREPORT_LIST_REQUEST,
    PASARGADREPORT_LIST_SUCCESS,
    PASARGADREPORT_LIST_FAIL,

    PASARGADINQUIRY_LIST_REQUEST,
    PASARGADINQUIRY_LIST_SUCCESS,
    PASARGADINQUIRY_LIST_FAIL
     
    
       } from "../constants/pasargadreportConstansts"


export const listPasargadreportReducers = (state = {pasargadreport:[]} , action) => {
    switch(action.type){
        case PASARGADREPORT_LIST_REQUEST:
            return { pasargadreport: [] , loading: true}
        case PASARGADREPORT_LIST_SUCCESS:
            return { pasargadreport: action.payload , loading: false}
        case PASARGADREPORT_LIST_FAIL:
            return { error: action.payload , loading: false}
        default:
            return state

    }

}



export const listPasargadInquiryReducers = (state = {pasargadinquiry:[]} , action) => {
    switch(action.type){
        case PASARGADINQUIRY_LIST_REQUEST:
            return { pasargadinquiry: [] , loading: true}
        case PASARGADINQUIRY_LIST_SUCCESS:
            return { pasargadinquiry: action.payload , loading: false}
        case PASARGADINQUIRY_LIST_FAIL:
            return { error: action.payload , loading: false}
        default:
            return state

    }

}


